import React, { ReactNode } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import logo from '../../../img/logo-idnot.png';
import invitationApi from '../../../network/api/invitationApi';
import { InvitationLinkInfo, VerifiedInvitation } from '../../../network/api/types/InvitationDTO';
import { CREATION, HOME_PAGE_ROUTE } from '../../../routes';
import Button from '../../common/Button';
import H4Title from '../../common/H4Title';
import Modal from '../../common/modals/Modal';
import { toastError, toastSuccess } from '../../common/Notification';
import Footer from '../../layout/Footer';
import Loader from '../../Loader';

interface EnrolementParams {
  entiteId: string;
  idnInvitor: string;
  token: string;
}

type Props = RouteComponentProps<EnrolementParams>;

type State = {
  verifiedInvitation: VerifiedInvitation,
  hasError: boolean,
  showRefuseInvitationPopin: boolean,
};

class EnrolementProcess extends React.Component<Props, State> {
  state: State = {
    verifiedInvitation: undefined,
    hasError: false,
    showRefuseInvitationPopin: false,
  };

  componentDidMount() {
    this.verifyInvitation();
  }

  verifyInvitation = () => {
    const { entiteId, idnInvitor, token } = this.props.match.params;
    const invitationLinkInfo: InvitationLinkInfo = { entiteId, idnInvitor, token };
    invitationApi.verifyInvitationLink(invitationLinkInfo)
      .then((response: VerifiedInvitation) => {
        this.setState({ verifiedInvitation: response });
      })
      .catch(() => {
        this.setState({ hasError: true });
      });
  };

  openRefuseInvitationPopin = () => {
    this.setState({ showRefuseInvitationPopin: true });
  };

  closeRefuseInvitationPopin = () => {
    this.setState({ showRefuseInvitationPopin: false });
  };

  refuseInvitation = () => {
    invitationApi.refuseInvitation(this.state.verifiedInvitation.id)
      .then(() => {
        toastSuccess(I18n.t('enrolement.refuse.success'));
        this.closeRefuseInvitationPopin();
        this.redirectToLogin();
      })
      .catch(() => toastError(I18n.t('message.ERROR')));
  };

  redirectToLogin = () => {
    this.props.history.push(HOME_PAGE_ROUTE);
  };

  redirectAndConnect = () => {
    window.location.href = this.state.verifiedInvitation.callback;
  };

  accountCreation = () => {
    this.props.history.push({
      pathname: CREATION,
      state: { verifiedInvitation: this.state.verifiedInvitation },
    });
  };

  render(): ReactNode {
    const { verifiedInvitation, showRefuseInvitationPopin, hasError } = this.state;
    return (
      <div className="enrolement-process">
        <div className="header">
          <img className="logo" src={logo} alt="logo" />
          <h3>
            <Translate value="HEADER.MY_ID" />
          </h3>
          <div className="subtitle">
            <Translate value="HEADER.UNIQUE_ACCOUNT" />
          </div>
        </div>
        <div className="content">
          {verifiedInvitation
            ? (
              <>
                {verifiedInvitation.id && !verifiedInvitation.isExpired
                && (
                  <div className="choice">
                    <H4Title>
                      {I18n.t('enrolement.title', { entity: verifiedInvitation.entityName })}
                    </H4Title>
                    <div className="label">
                      {I18n.t('enrolement.hello',
                        { prenom: verifiedInvitation.firstName, nom: verifiedInvitation.lastName })}
                    </div>
                    <div className="label">
                      {I18n.t('enrolement.continue', { entity: verifiedInvitation.entityName })}
                    </div>
                    <div className="choice-container">
                      <div className="choice-tile">
                        <div>
                          <div className="circle-container">
                            <div className="circle" />
                          </div>
                          <div className="title">{I18n.t('enrolement.account.title')}</div>
                          <div className="info">{I18n.t('enrolement.account.desc')}</div>
                        </div>
                        <Button
                          type="primary"
                          i18nKey="END_FORM.ACTION"
                          onClick={this.redirectAndConnect}
                        />
                      </div>
                      <div className="choice-tile">
                        <div>
                          <div className="circle-container">
                            <div className="circle" />
                          </div>
                          <div className="title">{I18n.t('enrolement.noAccount.title')}</div>
                          <div className="info">{I18n.t('enrolement.noAccount.desc')}</div>
                        </div>
                        <Button
                          type="primary"
                          i18nKey="enrolement.noAccount.button"
                          onClick={this.accountCreation}
                        />
                      </div>
                      <div className="choice-tile">
                        <div>
                          <div className="circle-container">
                            <div className="circle" />
                          </div>
                          <div className="title">{I18n.t('enrolement.refuse.title')}</div>
                          <div className="info">{I18n.t('enrolement.refuse.desc')}</div>
                        </div>
                        <Button
                          className="refuse"
                          type="primary"
                          i18nKey="enrolement.refuse.button"
                          onClick={this.openRefuseInvitationPopin}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {verifiedInvitation.id && verifiedInvitation.isExpired
                && (
                  <div className="message-info">
                    <h3 className="label">{I18n.t('enrolement.expired')}</h3>
                    <h3 className="label">{I18n.t('enrolement.expiredInfo', { entity: verifiedInvitation.entityName })}</h3>
                  </div>

                )}
                {(!verifiedInvitation.id || hasError)
                && (
                  <div className="message-info">
                    <h3 className="label">{I18n.t('enrolement.invalid')}</h3>
                    <h3 className="label">{I18n.t('enrolement.invalidInfo', { entity: verifiedInvitation.entityName })}</h3>
                  </div>
                )}
              </>
            )
            : <Loader />}
        </div>
        <Footer />
        <Modal
          isOpen={showRefuseInvitationPopin}
          className="refuse-invitation-modal"
        >
          <H4Title>
            {I18n.t('enrolement.refuse.modal.title')}
          </H4Title>
          <div className="label">{I18n.t('enrolement.refuse.modal.desc')}</div>
          <div className="label">{I18n.t('enrolement.refuse.modal.confirm')}</div>
          <div className="footer">
            <Button
              type="third"
              i18nKey="actions.CANCEL"
              onClick={this.closeRefuseInvitationPopin}
            />
            <Button
              type="primary"
              i18nKey="enrolement.refuse.modal.title"
              onClick={this.refuseInvitation}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default withRouter(EnrolementProcess);
